import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  IdentificationTypeTable,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

import axios from "axios";
import { useForm } from "react-hook-form";
import { authHeader } from "../../../header";
import { statusOptions } from "../options_common";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import { AllowAccess } from "../../../components/BlockAccess";

export const IdentificationType = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    description: "",
    identificationName: "",
    status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [identificationTypes, setIdentificationTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [, setSelectedOption] = useState(null);
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getIdentificationType();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      description: "",
      identificationName: "",
      status: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const getIdentificationType = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/identification-type?search=${search}`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      if (resultData) {
        setIdentificationTypes(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addIdentificationType = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/identification-type`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getIdentificationType();
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
        message.success({
          content: "Identification Type Created Successfully",
          style: {
            marginTop: "20vh",
          },
        });
      }
      return { formData };
    } catch (error) {
      const err = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const editIdentificationType = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/admin/identification-type/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getIdentificationType();
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
        message.success({
          content: "Identification Type Edited Successfully",
          style: {
            marginTop: "20vh",
          },
        });
      }
      return { formData };
    } catch (error) {
      const err = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      resetForm();
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const onFormSubmit = () => {
    addIdentificationType(formData);
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editIdentificationType(formData);
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      description: items.description,
      identificationName: items.name,
      status: items.status,
    });
    setEditedId(items.id);
    // eslint-disable-next-line no-restricted-globals
    setSelectedOption({ value: status, label: items.status });
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = identificationTypes?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getIdentificationType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="Identification Type"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Identification Type Management</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Identification Type..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_IDENTIFICATION_TYPE"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus"></Icon>
                      <span>Add Identification Type</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <IdentificationTypeTable
                IdentificationType={currentItems}
                modal={modal}
                handleView={() => setModal({ view: true })}
                handleEdit={() => setModal({ edit: true })}
                onEditClick={onEditClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {identificationTypes && identificationTypes.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={identificationTypes?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Identification Type found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Identification Type</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <input
                        type="text"
                        name="identificationName"
                        placeholder="Identification Type"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.rate && <span className="invalid">{errors.rate.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        placeholder="Your description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Identification Type</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <input
                        type="text"
                        name="identificationName"
                        defaultValue={formData.identificationName}
                        placeholder="Identification Type"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.identificationName && (
                        <span className="invalid">{errors.identificationName.message}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        value={statusOptions.filter(({ value }) => value === formData?.status)[0]}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        placeholder="Your description"
                        value={formData?.description}
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Update
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
